module.exports = __webpack_public_path__ + "img/1729146461669-IMG_4678.png.8a418040.webp";